import React from "react";
import * as S from "./styles";
export var CheckMark = function CheckMark(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, e), React.createElement("path", {
    fill: "4BA373",
    fillRule: "evenodd",
    d: "M1.322 12.713c-.43-.42-.43-1.099 0-1.518l1.556-1.517c.43-.419 1.126-.419 1.555 0l4.817 4.698L19.567 4.314c.43-.419 1.126-.419 1.555 0l1.556 1.517c.43.42.43 1.099 0 1.518l-12.65 12.337c-.43.419-1.126.419-1.556 0l-7.15-6.973z"
  }));
};